import { FC } from 'react';
import { ResourceText } from '../../../types/cms_shared_types';
import { Conditional } from '../../Common/Conditional';
import { RadioItem } from './RadioItem';

interface RadioDialogProps {
  prompt: string;
  options: ResourceText[];
  selectedKey: string;
  setSelectedKey: (value: string) => void;
  isSelected: (selectedKey: string, option: ResourceText) => boolean;
  informationText?: string;
  renderTextInsteadOfRadioItems: boolean;
  renderTextInsteadOfRadioItemsText?: string;
}

export const RadioDialog: FC<RadioDialogProps> = ({
  prompt,
  options,
  selectedKey,
  setSelectedKey,
  isSelected,
  informationText,
  renderTextInsteadOfRadioItems: renderTextInsteadOfRadioButtons,
  renderTextInsteadOfRadioItemsText: renderTextInsteadOfRadioButtonsText,
}) => {
  return (
    <div className="w-full sm:h-[78px]">
      <div className="flex flex-col mb-2.5 text-sm font-bold text-text-dark">{prompt}</div>
      <Conditional
        condition={renderTextInsteadOfRadioButtons}
        trueRender={
          <div className="pt-3 pb-4 text-sm font-medium text-text-dark">{renderTextInsteadOfRadioButtonsText}</div>
        }
        falseRender={
          <div className="flex flex-col pt-3">
            <div className="grid grid-cols-2 grid-rows-2 sm:flex sm:flex-row gap-x-8 gap-y-6">
              {options.map((option) => {
                return (
                  <RadioItem
                    key={option.key}
                    name={option.value}
                    isSelected={isSelected(selectedKey, option)}
                    onClick={() => setSelectedKey(option.key)}
                  />
                );
              })}
            </div>
            <div className="mt-4 text-xs sself-start text-text-gray">{informationText}</div>
          </div>
        }
      />
    </div>
  );
};
